import React from 'react';
import { ImageContentCardData } from 'types/image-content-card-data';
import { getImage, getSrc, getSrcSet } from 'gatsby-plugin-image';

const ImageContentCardLightSwiperSlide: React.FC<ImageContentCardData> = ({ cardImage, cardImageAlt = '', headline, subtext, buttonText, buttonUrl }) => {
    const cardImageData = getImage(cardImage || null);

    const cardImgSrc = cardImageData ? getSrc(cardImageData) : '/img/placeholder/image-content-card.jpg';

    const cardImgSrcSet = cardImageData ? getSrcSet(cardImageData) : '/img/placeholder/image-content-card.jpg 1x, /img/placeholder/image-content-card@2x.jpg 2x';

    return (
        <div className="swiper-slide">
            <a href={buttonUrl} className="image-content-card-light image-content-card-light--framed">
                <div className="image-content-card-light__image">
                    {cardImage && <img src={cardImgSrc} srcSet={cardImgSrcSet} alt={cardImageAlt} width={cardImageData?.width} height={cardImageData?.height} />}
                </div>
                {(headline || subtext || buttonText) && (
                    <div className="image-content-card-light__content">
                        {headline && <h3 className="card-headline h2">{headline}</h3>}
                        {subtext && <div className="card-subtext" dangerouslySetInnerHTML={{ __html: subtext }} />}
                        {buttonText && buttonUrl && <div className="card-button btn-text-caret"><span>{buttonText}</span></div>}
                    </div>
                )}
            </a>
        </div>
    );
};

export default ImageContentCardLightSwiperSlide;